import client from "../helpers/Client";

export async function getProvinces() {
  const resp = await client.get("/public/tkgm/provinces/");
  return resp.data.items || [];
}

export async function getDistricts(provinceId) {
  const resp = await client.get("/public/tkgm/districts/", { params: { province_id: provinceId } });
  return resp.data.items || [];
}

export async function getNeighborhoods(districtId) {
  const resp = await client.get("/public/tkgm/neighborhoods/", { params: { district_id: districtId } });
  return resp.data.items || [];
}

export async function getStreets(neighborhoodId) {
  const resp = await client.get("/public/tkgm/streets/", { params: { neighborhood_id: neighborhoodId } });
  return resp.data.items || [];
}

export async function getBuildings(streetId) {
  const resp = await client.get("/public/tkgm/buildings/", { params: { street_id: streetId } });
  return resp.data.items || [];
}
